import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "@/App";

const LegalFooter = () => {
  const { language } = useContext(AuthContext);
  const t = (es, ca) => language === "ca" ? ca : es;

  return (
    <div className="w-full py-4 mt-auto text-left pl-4 pr-32 sm:pl-6 text-[11px] text-gray-600 space-y-1">
      <div>
        <Link
          to="/legal"
          data-testid="footer-legal-link"
          className="hover:text-gray-400 transition-colors"
        >
          {t("Avisos Legales", "Avisos Legals")}
        </Link>
      </div>
      <div>
        <a href="mailto:hola@essencia-app.com" data-testid="footer-contact-email" className="hover:text-gray-400 transition-colors">
          hola@essencia-app.com
        </a>
      </div>
    </div>
  );
};

export default LegalFooter;
